/** @format */

import React from 'react';
import { Autocomplete } from '@mui/material';
import { Controller } from 'react-hook-form';
import { FormHelperText, InputLabel, TextField } from '@mui/material';
import {  withStyles } from '@mui/styles';
import { LabelLine } from 'components/InputV2/components';
import { LabelWithToolTip } from 'components';
import { useStyles } from './style';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(1),
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '1.5px 4px',
    },
    '& .MuiInputLabel-formControl': {
      top: '-7px',
      color: '#546e7a',
      fontSize: '12px',
    },
    '& .MuiInputAdornment-root': { color: '#546e7a' },
  },
}))(TextField);



const ComparativeAccount = (props) => {
  const {
    errors,
    control,
    selectedList = [],
    list = [],
    style,
    required = false,
    label = 'لیست حساب‌ها',
    tooltip,
  } = props;
  const classes = useStyles();
  const name = props?.name ?? 'comparativeAccount';

  // TODO: Use AutocompleteV instead

  return (
    <Controller
      className={classes.root}
      name={name}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          style={{ ...style }}
          selectOnFocus
          onChange={(event, newValue) => {
            onChange(newValue);
          }}
          id="comparativeAccount"
          isOptionEqualToValue={(option, value) => option.code === value.code}
          getOptionLabel={(option) => option.name}
          options={list}
          value={value}
          filterSelectedOptions
          getOptionDisabled={(option) =>
            !!selectedList.filter((item) => item.code === option.code).length
          }
          renderInput={(params) => (
            <>
              <InputLabel shrink htmlFor={params?.name} className={classes.label}>
                <LabelLine
                  label={<LabelWithToolTip label={label} description={tooltip} />}
                  required={required}
                />
              </InputLabel>
              <BootstrapInput {...params} variant="outlined" />
              <FormHelperText id="my-helper-text" className={classes.asterisk}>
                {errors?.[name]?.message}
              </FormHelperText>
            </>
          )}
        />
      )}
      control={control}
      defaultValue={null}
    />
  );
};

export default ComparativeAccount;
